export default "__VITE_ASSET__BZ1BfAYu__"